import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

const styles = ({ colors }: Theme) => createStyles({
  root: {
    display: 'inline-flex',
    '& path': {
      fill: colors.uIIconBase,
    },
  },
});

export default styles;
